export default __webpack_public_path__ + "static/twin-3acadb20c27ace93ab0132363b2e05f4.jpg";